import type { IRoute } from 'umi';
import _ from 'lodash';

interface MenuFilterInterface extends IRoute {
  permissions: string[];
}

/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser | undefined }) {
  const { currentUser = {} } = initialState || {};
  const { permissions = [] } = currentUser as API.CurrentUser;

  const permissionsObject = {};
  _.forEach(permissions, (v) => {
    permissionsObject[v] = true;
  });

  // perms 中拥有其中一个权限表示能访问
  const hasOne = (perms: string[]) => {
    let accessible = false;
    _.forEach(perms, (perm) => {
      if (accessible) {
        return;
      }
      accessible = permissionsObject[perm];
    });

    return accessible;
  };

  const hasAll = (perms: string[]) => {
    let accessible = false;
    _.forEach(perms, (perm) => {
      if (!permissionsObject[perm]) {
        return;
      }
      accessible = true;
    });

    return accessible;
  };

  // 路由上使用 (OR 关系)
  // {
  //   name: 'welcome',
  //   path: '/',
  //   component: '',
  //   access: 'routeFilter',
  //   routeFilter: ['create', 'update'],
  // },
  const routeFilter = (route: MenuFilterInterface) => {
    return hasOne(route.routeFilter);
  };

  return {
    ...permissionsObject,
    hasOne,
    hasAll,
    routeFilter,
  };
}
